/**
 * @fileoverview ESM bridge for TypeScript’s `./…polyfill.js` import specifier.
 *
 * @purpose Next.js webpack resolves the `.js` path literally; the implementation lives in the
 *   sibling `.ts` module. Node/tsx loads this file first, then executes the TypeScript side effects.
 * @ownership @korvo/core error helpers
 * @dependencies `./console-error-normalized-polyfill.ts`
 */
import './console-error-normalized-polyfill.ts';
